import { combineReducers } from 'redux';

import heroBlock from 'app/features/success/heroBlock/reducers/organic';
import offlineViewingBlock from 'app/features/success/offlineViewingBlock/reducers/organic';
import latestNewsBlock from 'app/features/success/latestNewsBlock/reducers/organic';
import helpCenterBlock from 'app/features/success/helpCenterBlock/reducers/organic';

const organic = combineReducers({
  heroBlock,
  offlineViewingBlock,
  latestNewsBlock,
  helpCenterBlock,
});

export default organic;
